export const transformNullishFromData = (data) => {
  return Object
    .keys(data)
    .reduce((obj, key) => {
      obj[key] = data[key] || null;

      return obj;
    }, {})
} 